<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import VueToastr from "vue-toastr";
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import Spinner from "../common/spinner/Spinner.vue";
import WhatsappNewsletterGeneralInfos from "./WhatsappNewsletterGeneralInfos.vue";
import SuggestionInput from "../common/mention-input/SuggestionInput.vue";
import {Picker} from "emoji-mart-vue";
import {emojiPickerGerman} from "../common/emoji-picker/emoji-picker-i18n";

const FilePond = vueFilePond(
    FilePondPluginImagePreview,
);

export default {
  name: "WhatsappNewsletterForm",
  props: ['record', 'templates', 'phoneNumbers', 'selections', 'creator', 'client', 'isAdmin'],
  components: {
    Picker,
    SuggestionInput,
    WhatsappNewsletterGeneralInfos,
    Spinner,
    FilePond,
    VueToastr,
  },
  data() {
    return {
      german: emojiPickerGerman,
      showEmojiPicker: false,
      lastFocusedElement: null,
      phoneNumbersOptions: [],
      sendTypes: [
        {
          value: 'whatsapp_user',
          label: 'An alle WhatsApp-User zum Startzeitpunkt'
        },
        {
          value: 'whatsapp_user_time',
          label: 'An alle WhatsApp-User zu einem Zeitpunkt'
        },
        {
          value: 'whatsapp_interested',
          label: 'Bei Newsletter-Interesse'
        },
        {
          value: 'registration',
          label: 'Bei WhatsApp-Newsletter Registrierung'
        },
        {
          value: 'whatsapp_unsubscription',
          label: 'Bei WhatsApp-Newsletter Abmeldung'
        },
        {
          value: 'selection',
          label: 'An Kunden aus smart.KIS Selektion'
        },
        {
          value: 'sale',
          label: 'Nach Einkauf'
        },
        {
          value: 'birthday',
          label: 'Am Geburtstag des WhatsApp-Users'
        },
        {
          value: 'unrecognized_messages',
          label: 'Bei nicht zuzuordnenden WhatsApp-Nachrichten der Kunden'
        }
      ],
      loading: false,
      mode: 'create',
      pond: null,
      page: 'message',
      components: [
        {
          type: 'header',
        },
        {
          type: 'body',
          parameters: []
        },
        {
          type: 'quick_reply',
          replies: []
        }
      ],
      selectedTemplate: '',
      name: '',
      file: '',
      send_type: 'whatsapp_user',
      send_to_selection_id: '',
      embargo_until: '',
      test_phone_numbers: '',
      additional_at_registration: false,
      error: '',
      editorConfig: {
        toolbar: [
          [
            'Bold',
            'Italic',
            'Undo',
            'Redo'
          ]
        ],
      },
    };
  },

  mounted() {

    window.addEventListener('focusin', this.handleFocus);

    if (Object.values(this.templates).length > 0) {
      this.selectedTemplate = Object.values(this.templates)[0];
    }

    if (this.record) {
      this.mode = 'edit';
      this.initData();
    }

    this.parseSelectedTemplate();
    this.changeTemplateData(!this.record)
  },
  beforeDestroy() {
    window.removeEventListener('focusin', this.handleFocus);
  },
  methods: {
    parseSelectedTemplate() {
      if (typeof this.selectedTemplate.header === 'string') {
        this.selectedTemplate.header = JSON.parse(this.selectedTemplate.header);
      }

      if (typeof this.selectedTemplate.body === 'string') {
        this.selectedTemplate.body = JSON.parse(this.selectedTemplate.body);
      }

      if (typeof this.selectedTemplate.buttons === 'string') {
        this.selectedTemplate.buttons = JSON.parse(this.selectedTemplate.buttons);
      }
    },
    initData() {
      this.name = this.record.name;
      this.send_type = this.record.send_type;
      this.embargo_until = this.record.embargo_until;
      this.test_phone_numbers = this.record.test_phone_numbers;
      this.components = JSON.parse(this.record.components);

      if (this.record.send_type === 'selection') {
        this.send_to_selection_id = this.record.send_to_selection_id;
      }

      this.selectedTemplate = this.templates.filter(template => template.id === this.record.whatsapp_template_id)[0];

      if (this.record.file) {
        setTimeout(() => {
          this.pond.addFile(this.record.file);
        }, 500);
      }
    },

    changePage(page) {

      if (page === 'send_data') {

        if (!this.name) {
          this.$refs.mytoast.e('Bitte geben Sie einen Namen für den Newsletter ein', 'Fehler');
          return;
        }

        if (!this.selectedTemplate) {
          this.$refs.mytoast.e('Bitte wählen Sie eine Vorlage aus', 'Fehler');
          return;
        }

        if (this.components[0].parameters.some(parameter =>
            parameter.type === 'text' &&
            'text' in parameter &&
            (!parameter.text || parameter.text.trim() === '')
        )) {
          this.$refs.mytoast.e('Bitte füllen Sie alle Platzhalter im Header aus', 'Fehler');
          return;
        }

        if (this.components[1].parameters.some(parameter =>
            parameter.type === 'text' &&
            'text' in parameter &&
            (!parameter.text || parameter.text.trim() === '')
        )) {
          this.$refs.mytoast.e('Bitte füllen Sie alle Platzhalter im Haupttext aus', 'Fehler');
          return;
        }

        if (this.components[2].replies.length > 0 && this.components[2].replies.some(reply => !reply.quick_reply)) {
          this.$refs.mytoast.e('Bitte füllen Sie alle Schnellantworten aus', 'Fehler');
          return;
        }
      }

      this.page = page;
    },
    acceptedFiles() {
      if (!this.selectedTemplate.header) return '';

      switch (this.selectedTemplate.header?.format ?? null) {
        case 'IMAGE':
          return 'image/jpeg, image/png, image/jpg';
        case 'VIDEO':
          return 'video/mov, video/mp4, video/QuickTime';
        case 'DOCUMENT':
          return 'application/pdf';
        default:
          return '';
      }
    },
    getUploadType() {
      if (!this.selectedTemplate.header) return '';

      switch (this.selectedTemplate.header.format) {
        case 'IMAGE':
          return 'Bild';
        case 'VIDEO':
          return 'Video';
        case 'DOCUMENT':
          return 'Dokument';
        default:
          return '';
      }
    },
    handleFilePondInit() {
      this.pond = this.$refs.pond;
    },
    async saveNewsletter(action = 'save') {

      if (action === 'send' && !confirm('Sind Sie sicher, dass Sie den Newsletter versenden möchten?')) {
        return;
      }

      if (action === 'stop' && !confirm('Sind Sie sicher, dass Sie den Newsletter stoppen möchten?')) {
        return;
      }

      if (this.send_type === 'selection' && !this.send_to_selection_id) {
        this.$refs.mytoast.e('Bitte wählen Sie eine Selektion aus', 'Fehler');
        return;
      }

      this.loading = true;

      const formData = new FormData();

      if (this.selectedTemplate.header && this.selectedTemplate.header.format && this.selectedTemplate.header.format !== 'TEXT') {
        const files = this.pond.getFiles();
        files.forEach(fileItem => {
          formData.append('file', fileItem.file);
        });
      }

      formData.append('name', this.name);
      formData.append('components', JSON.stringify(this.components));
      formData.append('whatsapp_template_id', this.selectedTemplate.id);
      formData.append('client_id', this.client?.id);

      formData.append('send_type', this.send_type);
      formData.append('send_to_selection_id', this.send_to_selection_id);
      formData.append('action', action);

      formData.append('test_phone_numbers', this.test_phone_numbers);

      if (this.send_type === 'whatsapp_user_time') {
        formData.append('embargo_until', this.embargo_until);
      }

      try {

        let url = '/backend/whatsapp_newsletters';

        if (this.mode === 'edit') {
          url = `/backend/whatsapp_newsletters/${this.record.id}`;
        }

        await axios.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(() => {
          this.error = '';
          window.location.href = this.isAdmin
              ? `/backend/whatsapp_newsletters?client_id=${this.client?.id}`
              : '/backend/whatsapp_newsletters';
        });


        // Handle successful upload
      } catch (error) {

        this.loading = false;
        this.error = [['Ein Fehler ist aufgetreten']];

        if (error.response.data.errors) {
          this.error = error.response.data.errors;
        }
      }
    },
    toTestPhones() {

      if (!confirm('Sind Sie sicher, dass Sie an die Test-Telefonnummer aussenden möchten?')) {
        return;
      }

      this.loading = true;

      axios.post('/backend/whatsapp_newsletters/to-testphones', {
        id: this.record.id,
        test_phone_numbers: this.test_phone_numbers,
        components: this.components
      }).then(() => {
        this.$refs.mytoast.s('An Test-Telefonnummer ausgesendet', "Erfolgreich");

        this.loading = false;
        this.error = '';
      }).catch((error) => {

        this.error = error.response.data.errors;
        this.loading = false;
      });
    },
    selectTemplate(event) {
      this.selectedTemplate = Object.values(this.templates).find(template => template.name === event.target.value);

      this.parseSelectedTemplate();
      this.changeTemplateData()
    },
    changeTemplateData(reset = true) {

      if (reset) {
        this.components[0].parameters = [];
        this.components[1].parameters = [];
        this.components[2].replies = [];
      }

      if (this.selectedTemplate.buttons.buttons.length > 0) {

        if (this.components[2].replies.length === 0) {

          this.selectedTemplate.buttons.buttons.forEach(button => {
            if (button.type === 'QUICK_REPLY') {
              this.components[2].replies.push({
                button: button.text,
                quick_reply: ''
              });
            }
          });
        }
      }

      let matchesBody = this.selectedTemplate.body.text.match(/{{(.*?)}}/g);

      if (matchesBody) {

        matchesBody.forEach(match => {
          const index = match.replace(/{{|}}/g, '')

          if (reset) {
            this.components[1].parameters.push({
              label: index,
              type: 'text',
              text: ''
            });
          }
        });
      }

      if (this.selectedTemplate.header && this.selectedTemplate.header.format && this.selectedTemplate.header.format === 'TEXT') {

        let matchesHeader = this.selectedTemplate.header.text.match(/{{(.*?)}}/g);

        if (matchesHeader) {

          matchesHeader.forEach(match => {
            const index = match.replace(/{{|}}/g, '')

            if (reset) {
              this.components[0].parameters.push({
                label: index,
                type: 'text',
                text: ''
              });
            }
          });
        }
      }
    },
    handleFocus(event) {
      const element = event.target;
      if (element.tagName === 'TEXTAREA' || (element.tagName === 'INPUT' && element.type === 'text')) {
        this.lastFocusedElement = element;
      }
    },
    transformText(type) {
      const textField = this.lastFocusedElement;

      if (!textField) return;

      const id = textField.id;

      const start = textField.selectionStart;
      const end = textField.selectionEnd;

      if (start === end) return; // Kein Text ausgewählt

      const selectedText = textField.value.substring(start, end);

      let formattedText = '';

      switch (type) {
        case 'bold':
          formattedText = `*${selectedText}*`;
          break;
        case 'italic':
          formattedText = `_${selectedText}_`;
          break;
        case 'strikethrough':
          formattedText = `~${selectedText}~`;
          break;
      }

      this.components[2].replies[id].quick_reply = textField.value.substring(0, start) +
          formattedText +
          textField.value.substring(end);
    },
    pickEmoji(emoji) {
      const textField = this.lastFocusedElement;

      if (!textField) return;

      const id = textField.id;

      const start = textField.selectionStart;
      const end = textField.selectionEnd;

      this.components[2].replies[id].quick_reply = textField.value.substring(0, start) +
          emoji.native +
          textField.value.substring(end);

      this.showEmojiPicker = false;
    }
  }
}
</script>

<template>
  <div>
    <vue-toastr ref="mytoast"></vue-toastr>
    <div v-if="loading">
      <spinner></spinner>
    </div>
    <div>
      <vue-toastr ref="mytoast"></vue-toastr>
      <div class="d-flex" style="margin-bottom: 20px;">
        <button class="btn btn-success" :disabled="page === 'message'" @click="changePage('message')">Nachricht</button>
        <button class="btn btn-success" :disabled="page === 'send_data'" @click="changePage('send_data')">
          Aussendungsdaten
        </button>
      </div>

      <div class="alert alert-danger" v-if="error">
        <ul>
          <li v-for="errorMsg in error">{{ errorMsg[0] }}</li>
        </ul>
      </div>

      <div :class="{'hidden': page === 'send_data'}">

        <whatsapp-newsletter-general-infos :record="record" :templates="templates"
                                           :send-types="sendTypes"></whatsapp-newsletter-general-infos>

        <div class="panel panel-default" v-if="isAdmin">
          <div class="panel-heading">
            <span style="font-weight: 700" class="text-uppercase">Mandant</span>
          </div>
          <div class="panel-body">
            <div class="form-group">
              <input type="text" class="form-control" :value="client && client.name" disabled>
            </div>
          </div>
        </div>

        <div class="panel panel-default">
          <div class="panel-heading">
            <span style="font-weight: 700" class="text-uppercase">WhatsApp</span>
          </div>
          <div class="panel-body">
            <div class="form-group">
              <label for="">Aussendungsart</label>
              <select class="form-control" v-model="send_type">
                <option :value="type.value" v-for="type in sendTypes">{{ type.label }}</option>
              </select>
              <div v-if="send_type === 'whatsapp_user_time'">
                <label for="">Zeitpunkt</label>
                <input type="datetime-local" class="form-control" v-model="embargo_until">
              </div>
              <div v-if="send_type === 'selection'">
                <label for="">Selektion</label>
                <select class="form-control" v-model="send_to_selection_id">
                  <option v-for="selection in selections" :value="selection.id">{{ selection.name }}</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label for="">Newsletter Titel*</label>
              <a class="fa fa-question-circle" v-tippy
                 content="Interner Titel für die Newsletter-Übersicht. "></a>
              <input type="text" v-model="name" class="form-control" required>
            </div>
            <div v-if="Object.values(templates).length > 0">
              <div class="form-group">
                <label for="">Whatsapp Vorlage</label>
                <a class="fa fa-question-circle" v-tippy
                   content="Nur genehmigte Vorlagen werden zur Auswahl angezeigt und können für den Newsletter verwendet werden."></a>
                <select class="form-control" @change="selectTemplate($event)">
                  <option v-for="template in templates" :value="template.name"
                          :selected="template.id === selectedTemplate.id">{{ template.name }}
                  </option>
                </select>
              </div>

              <div class="form-group"
                   v-if="selectedTemplate.header && selectedTemplate.header.format && selectedTemplate.header.format !== 'TEXT'">
                <label for="">Header ({{ getUploadType() }})</label>
                <a class="fa fa-question-circle" v-tippy
                   content="Der Headertyp wurde in der Vorlage definiert. Es kann nur eine Datei vom gleichen Headertypen (Bild, Dokument oder Video) wie in der Vorlage eingesetzt werden."></a>
                <div class="whatsapp-file">
                  <file-pond
                      name="image"
                      ref="pond"
                      label-idle="Hier klicken oder Datei reinziehen..."
                      :allow-multiple="false"
                      :accepted-file-types="acceptedFiles()"
                      maxFileSize="10MB"
                      :instant-upload="false"
                      @init="handleFilePondInit"
                  />
                </div>

                <div class="alert alert-info" style="max-width: 900px"
                     v-if="['IMAGE', 'VIDEO'].includes(selectedTemplate.header.format)">
                  <i class="fa fa-info-circle"></i>
                  Wir empfehlen quadratische Formate der Bild- oder Videodateien, da diese ideal in der Vorschau der
                  WhatsApp-Nachricht angezeigt werden.
                </div>
              </div>
              <div
                  v-if="selectedTemplate.header && selectedTemplate.header.format && selectedTemplate.header.format === 'TEXT'">
                <div class="form-group">
                  <label for="">Header-Text</label>
                  <textarea disabled v-model="selectedTemplate.header.text" class="form-control"></textarea>
                </div>

                <div class="row">
                  <div v-for="(header, index) in components[0].parameters" class="col-md-4"
                       v-if="components[0].parameters.length > 0">
                    <label :for="'variable_' + index">Text für Platzhalter {{ header.label }}</label>
                    <suggestion-input :suggestions="['@username']" v-model="header.text"></suggestion-input>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="">Haupttext</label>
                <a class="fa fa-question-circle" v-tippy
                   content="Der Haupttext wurde in der Vorlage definiert und kann hier nicht geändert werden. Wurden in der Vorlage Platzhalter verwendet, werden diese unten angezeigt und müssen für den Versand des Newsletter befüllt werden."></a>
                <textarea disabled v-model="selectedTemplate.body.text" class="form-control"
                          cols="10" rows="10"></textarea>
              </div>

              <div class="row">
                <div v-for="(body, index) in components[1].parameters" class="col-md-4"
                     v-if="components[1].parameters.length > 0">
                  <label :for="'variable_' + index">Text für Platzhalter {{ body.label }}</label>
                  <suggestion-input :suggestions="['@username']" v-model="body.text"></suggestion-input>
                </div>
              </div>


              <div v-if="selectedTemplate.buttons.buttons.length > 0">

                <div v-if="selectedTemplate.interaction.includes('cta')">
                  <h3 style="border-bottom: 1px solid #f0f0f0">Call-To-Action Buttons</h3>

                  <div v-for="button in selectedTemplate.buttons.buttons" style="margin-top: 5px">
                    <a v-if="button.type === 'URL'" target="_blank" class="btn btn-outline btn-success btn-sm"
                       :href="button.url"
                       type="button">{{
                        button.text
                      }}</a>

                    <a v-if="button.type === 'PHONE_NUMBER'" target="_blank" class="btn btn-outline btn-success btn-sm"
                       :href="`tel:${button.phone_number}`" type="button">{{
                        button.text
                      }}</a>
                  </div>
                </div>
                <br>
                <div v-if="selectedTemplate.interaction.includes('quick_reply')">
                  <h3 style="border-bottom: 1px solid #f0f0f0">Schnellantworten</h3>

                  <div>
                    <button
                        class="textarea-button"
                        @click="transformText('bold')"
                        style="font-weight: bold">
                      B
                    </button>
                    <button
                        @click="transformText('italic')"
                        class="textarea-button"
                        style="font-style: italic">
                      I
                    </button>
                    <button
                        @click="transformText('strikethrough')"
                        class="textarea-button"
                        style="text-decoration: line-through">
                      S
                    </button>
                    <button
                        class="textarea-button"
                        style="font-size: 10px"
                        @click="showEmojiPicker = !showEmojiPicker"
                    >
                      😊
                    </button>
                    <picker :i18n="german" v-if="showEmojiPicker" @select="pickEmoji" :native="true"
                            :showPreview="false"
                            color="#304050"
                            :style="{ position: 'absolute', zIndex: 9999}"/>
                  </div>

                  <div v-for="(button, index) in components[2].replies" style="margin-top: 5px">

                    <label for="">{{ button.button }}</label>
                    <input type="text" class="form-control" :id="index" v-model="button.quick_reply">
                  </div>
                </div>
              </div>

            </div>
            <div v-else>
              <div class="alert alert-info">
                <p>
                  Es sind noch keine Vorlagen vorhanden. Bitte erstellen Sie eine Vorlage, um diese hier auswählen zu
                  können.
                </p>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-primary" @click="changePage('send_data')">Weiter</button>
      </div>

      <div :class="{'hidden': page === 'message'}">
        <div class="panel panel-default">
          <div class="panel-heading">
          </div>
          <div class="panel-body">
            <label for="">Test-Telefonnummer</label>
            <p class="fa fa-info-circle" v-tippy
               content="Bitte trennen Sie Telefonnummern mit einem Komma"></p>
            <input type="text" v-model="test_phone_numbers" class="form-control">
            <br>
            <p class="fa fa-info-circle" v-if="!record" v-tippy
               content="Bitte speichern Sie den Newsletter, bevor Sie ihn an Testpersonen versenden können."></p>
            <button name="submit" class="btn btn-secondary form-control" @click="toTestPhones"
                    :class="record ? 'btn-primary' : 'btn-secondary'" :disabled="!record">
              <i class="fa fa-mail-forward"></i>
              An Test-Telefonnummer aussenden
            </button>
            <button name="submit" class="btn btn-success form-control"
                    v-if="!record || (record && !['sent', 'started', 'stopped'].includes(record.status))"
                    style="margin-top: 10px;"
                    @click="saveNewsletter">
              <i class="fa fa-mail-forward"></i> Newsletter abspeichern
            </button>
            <button name="submit" class="btn btn-success form-control"
                    v-if="!record || (record && !['sent', 'started', 'stopped'].includes(record.status))"
                    style="margin-top: 10px;"
                    @click="saveNewsletter('send')">
              <i class="fa fa-mail-forward"></i>
              Newsletter abspeichern und versenden
            </button>
            <button name="submit" class="btn btn-success form-control"
                    style="margin-top: 10px;"
                    v-if="record && record.status === 'started'"
                    @click="saveNewsletter('stop')">
              <i class="fa fa-mail-forward"></i>
              Newsletter stoppen
            </button>

            <div class="alert alert-info" v-if="record && record.status === 'started'" style="margin-top: 10px;">
              <p>Der Newsletter wurde gestartet und kann nicht mehr bearbeitet werden.</p>
            </div>

            <div class="alert alert-info" v-if="record && record.status === 'stopped'" style="margin-top: 10px;">
              <p>Der Newsletter wurde gestoppt und kann nicht mehr bearbeitet werden.</p>
            </div>

            <div class="alert alert-info" v-if="record && record.status === 'sent'" style="margin-top: 10px;">
              <p>Der Newsletter wurde versendet und kann nicht mehr bearbeitet werden.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>

</style>
